namespace Dashboard {

    import PassengerType = Core.Booking.PassengerType;
    import CrossSellType = Core.Booking.CrossSellType;

    export interface IFlightExtrasService {
        getOptionsData(bookingId: number);
        addOptionsToBooking(request, requireCardValidation);
        finaliseOptions(request);
    }

    interface IExtraProduct {
        CrossSellType: CrossSellType;
        Price: {
            CurrencyCode: string;
            Value: number;
        };
        Priority: number | null;
        IsFlightExtra: boolean;
        BookingId: number;
        Name: string;
        Icon: string;
        Code: string;
    }

    export class FlightExtrasService implements IFlightExtrasService {

        public extraProperties = {
            Bags: {
                Icon: 'icon-baggage',
                Code: 'HOLDBAGS'
            },
            Seats: {
                Icon: 'icon-seating',
                Code: 'SEATS'
            }
        };

        private extrasCache = {};

        constructor(
            private $http: ng.IHttpService,
            private dateUtil,
            private paymentDetailsService,
            private flightSeatPlanService,
            private $q: ng.IQService,
            private broker: Core.Broker) {

            // make sure cross sells are updated after a payment
            broker.subscribe('flightExtraService', 'paymentComplete', () => this.extrasCache = {});
        }


        getOptionsData(bookingId: number) {
            return this.$http.post('/api2/bookings/flights/checkoptions', {
                BookingId: bookingId,
                CultureCode: TRPCONFIG.Domain.CultureCode,
                CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                DomainId: TRPCONFIG.Domain.DomainId
            }).then( ({data}) => {
                // multi sector seat selection not yet supported
                const legs = data && data.Flight && data.Flight.Legs;
                const numberOfInfants = _.remove(data.Passengers, (p: any) => p.Type === PassengerType.Infant).length;
                const SeatPlan : TR.FlightSeatPlan | null = legs && legs.length && legs.length <= 2
                    ? {
                        Segments: {
                            Outbound: <TR.SeatPlanSegment[]>legs[0].Segments,
                            Inbound: <TR.SeatPlanSegment[]>legs[1].Segments
                        },
                        Passengers: <TR.SeatPlanPassenger[]>_.sortBy(data.Passengers, 'Type')
                            .map((p: any, pIndex) => _.defaults({
                                Id: p.Id,
                                Seats: _.flatMap(legs, leg => leg.Segments.map(seg => ({
                                    Number: null,
                                    Price: 0,
                                    LegId: leg.LegId,
                                    Segement: seg.SegmentHash //intentionally misspelt
                                }))),
                                IsChild: p.Type === PassengerType.Child,
                                HasInfant: p.Type === PassengerType.Adult && pIndex < numberOfInfants
                            }, p))
                    }
                    : null;
                SeatPlan && this.flightSeatPlanService.addMinCostPerPerson(SeatPlan);
                return _.defaults(data, { SeatPlan });
            });
        }

        getExtrasCrossSell(bookingId: number) {
            if (this.extrasCache[bookingId]) {
                return this.$q.when(this.extrasCache[bookingId]);
            }
            let extras:any = [];
            return this.getOptionsData(bookingId).then((options: any) => {
                if (options && options.CanAddBags && options.BagOptions && options.BagOptions.length > 0) {
                    let extraBags: IExtraProduct = {
                        CrossSellType: CrossSellType.Baggage,
                        Price: {
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            Value: options.BagOptions[0].UnitAmount / 2
                        },
                        Priority: null,
                        IsFlightExtra: true,
                        BookingId: bookingId,
                        Name: 'ADDBAGGAGE',
                        Icon: this.extraProperties.Bags.Icon,
                        Code: this.extraProperties.Bags.Code
                    };

                    extraBags.Priority = extras.push(extraBags) - 1;
                }
                if (TRPCONFIG.Domain.DashboardAddSeatsEnabled && options && options.CanAddSeats) {
                    let extraSeats: IExtraProduct = {
                        CrossSellType: CrossSellType.Seats,
                        Price: {
                            CurrencyCode: TRPCONFIG.Domain.CurrencyCode,
                            Value: options.SeatPlan.minCostPerPerson
                        },
                        Priority: null,
                        IsFlightExtra: true,
                        BookingId: bookingId,
                        Name: 'ADDSEATS',
                        Icon: this.extraProperties.Seats.Icon,
                        Code: this.extraProperties.Seats.Code
                    };

                    extraSeats.Priority = extras.push(extraSeats) - 1;
                }
                this.extrasCache[bookingId] = extras;
                return extras;
            }, () => extras);
        }

            //Transaction
        addOptionsToBooking(request, requireCardValidation) {
            if (requireCardValidation) {
                const paymentRequest = request.PaymentRequest;
                const validateRequest = {
                    CardNumber: TRPCONFIG.Domain.PCICompliant ?
                        paymentRequest.CardNumberMasked :  paymentRequest.CardNumber,
                    StartDate: paymentRequest.CardStartYear && paymentRequest.CardEndMonth
                        && this.dateUtil.serialiseDate(new Date(
                            paymentRequest.CardStartYear,
                            paymentRequest.CardStartMonth)),
                    ExpiryDate: this.dateUtil.serialiseDate(
                        new Date(paymentRequest.CardEndYear, paymentRequest.CardEndMonth)),
                    CV2: paymentRequest.CardCvc,
                    IssueNumber: paymentRequest.CardIssueNumber
                };

                return this.paymentDetailsService.validateCard(validateRequest).then((response: any)=> {
                    if (response.Success) {
                        return this._clear(request);
                    }
                    return this.$q.when(response);
                });
            }

            return this._clear(request);
        }

         _clear(request) {
             return this.$http.post('/api2/bookings/flights/addoptions', request).then((result:any) => result.data);
        }

        finaliseOptions(request) {
            return this.$http.post('/api2/bookings/flights/finaliseoptions', request).then(result => result.data);
        }

    }

    angular
        .module('dashboard')
        .service('flightExtrasService', FlightExtrasService);

}
